import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { ArticleResponse, ArticlesResponse } from "./ArticlesTypes"
import { toast } from "react-toastify";
const ENDPOINT_ARTICLES = "articles";

const getArticles = (token: string) => {
  const articlesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_ARTICLES as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ArticlesResponse)
  // void toast.promise(articlesResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });

  return articlesResult;
};

const getArticleById = (token: string, idArticle: number) => {
  const endpoint = `${ENDPOINT_ARTICLES}/${idArticle}`;

  const articleResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ArticleResponse);
  // void toast.promise(articleResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });
  return articleResult;
};


const getArticlesByCategory = (token: string, categoryId: number) => {
  const endpoint = `categories/${categoryId}/${ENDPOINT_ARTICLES}`;

  const articlesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ArticlesResponse)
  // void toast.promise(articlesResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });

  return articlesResult;
};

const getArticlesByCategoryBySpace = (token: string, categoryId: number, spaceId : number) => {
  const endpoint = `categories/${categoryId}/${spaceId}/${ENDPOINT_ARTICLES}`;

  const articlesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ArticlesResponse)
  // void toast.promise(articlesResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });

  return articlesResult;
};

const getArticleByCategoryBySpace = (token: string, categoryId: number, spaceId : number) => {
  const endpoint = `categories/${categoryId}/${spaceId}/article`;

  const articleResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ArticleResponse)
  // void toast.promise(articlesResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });

  return articleResult;
};


const createArticle = async (token: string, article: { id: number; title: string; content: string; image: string; startDate: number; endDate: number; spaceId: number; categoryId: number;}) => {
  const BODY = JSON.stringify({ 
    "Id": article.id,
    "Title": article.title,
    "Content": article.content,
    "Image": article.image,
    "StartDate": article.startDate,
    "EndDate": article.endDate,
    "SpaceId": article.spaceId,
    "CategoryId": article.categoryId,
  });

  const articlesResult = genericCoworkerCompanionAPICall(
    token,
    "POST",
    `${ENDPOINT_ARTICLES}`,
    BODY
  )

  await toast.promise(
    articlesResult,
    {
      success: 'Article created',
      pending: 'Creating Article',
      error: 'Contact support',
    });

};

const deleteArticle = async (token: string, id: number) => {

  const articleResult = genericCoworkerCompanionAPICall(
    token,
    "DELETE",
    `${ENDPOINT_ARTICLES}/${id}`,
    ""
  )

  await toast.promise(
    articleResult,
    {
      success: 'Article deleted',
      pending: 'Deleting Article',
      error: 'Contact support',
    });

};

const updateArticle = async (token: string, article: { id: number; title: string; content: string; image: string; startDate: number; endDate: number; spaceId: number; categoryId: number;}) => {
  const BODY = JSON.stringify({
    "Title": article.title,
    "Content": article.content,
    "Image": article.image,
    "StartDate": article.startDate,
    "EndDate": article.endDate,
    "SpaceId": article.spaceId,
    "CategoryId": article.categoryId,
  });

  const articlesResult = genericCoworkerCompanionAPICall(
    token,
    "PUT",
    `${ENDPOINT_ARTICLES}/${article.id}`,
    BODY
  )

  await toast.promise(
    articlesResult,
    {
      success: 'Article edited',
      pending: 'Editing Article',
      error: 'Contact support',
    });

};

export { getArticles, getArticleById, createArticle, deleteArticle, updateArticle, getArticlesByCategory, getArticlesByCategoryBySpace, getArticleByCategoryBySpace };
